import { useState, useEffect } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import SuperAdminSidebar from "./SuperAdminSidebar";
import { RiEyeFill, RiEyeCloseFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import instance from "../../services/endpoint";
import { toast } from "react-toastify";
import "../../styles/styles.css"; // Assuming you have a styles.css file for custom styles

const CreateUsers = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [value, setValue] = useState({
    FullName: "",
    Email: "",
    Phone: "",
    Account_Type: "",
    Password: "",
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;
    if (!password) {
      return "Password is required.";
    } else if (!passwordRegex.test(password)) {
      return "Password must include one uppercase letter, one special symbol, one number, and be 8–20 characters long.";
    }
    return "";
  };

  const validateFields = (requiredFields) => {
    const errors = {};
    requiredFields.forEach((field) => {
      if (!value[field]) {
        errors[field] = `${field.replace("_", " ")} is required`;
      }
    });

    const passwordError = validatePassword(value.Password);
    if (passwordError) {
      errors.Password = passwordError;
    }

    return errors;
  };

  const handleChange = (e) => {
    const { name, value: inputVal } = e.target;
    setValue((prev) => ({
      ...prev,
      [name]: inputVal,
    }));

    // Live field error clearing
    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

useEffect(() => {
  if (value.Password !== "") {
    const passwordError = validatePassword(value.Password);
    setFieldErrors((prevErrors) => ({
      ...prevErrors,
      Password: passwordError,
    }));
  } else {
    setFieldErrors((prevErrors) => ({
      ...prevErrors,
      Password: "",
    }));
  }
}, [value.Password]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateFields(["FullName", "Email", "Phone", "Account_Type", "Password"]);
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      await instance.post("/api/v1/auth/register", value);
      setIsLoading(false);
      setSuccess(true);
      toast.success("User registered successfully");
    navigate("/userlogindetails", { state: { userData: value } });
    } catch (error) {
      setIsLoading(false);
      setError(error.response?.data?.message || "An unexpected error occurred.");
    }
  };

  useEffect(() => {
    document.title = 'Register | Bitstek Advisory';
    if (success) {
      setSuccess(false);
    }
  }, [success]);

  return (
    <>
      <SuperAdminSidebar />
      <Container className="card mt-4">
        <h4 className="text-center text-primary" style={{ fontWeight: "bold" }}>
          Create New User
        </h4>
        <hr />
        <Row className="mb-3 justify-content-center">
          <Col md={6}>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label className="text-start d-block" style={{ fontWeight: "bold" }}>
                  Full Name
                </Form.Label>
                <Form.Control
                  type="text"
                  name="FullName"
                  placeholder="Enter Full Name"
                  value={value.FullName}
                  onChange={handleChange}
                  isInvalid={!!fieldErrors.FullName}
                  required
                />
                <Form.Control.Feedback type="invalid">{fieldErrors.FullName}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="text-start d-block" style={{ fontWeight: "bold" }}>
                  Email
                </Form.Label>
                <Form.Control
                  type="email"
                  name="Email"
                  placeholder="Enter Email"
                  value={value.Email}
                  onChange={handleChange}
                  isInvalid={!!fieldErrors.Email}
                  required
                />
                <Form.Control.Feedback type="invalid">{fieldErrors.Email}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="text-start d-block" style={{ fontWeight: "bold" }}>
                  Phone Number
                </Form.Label>
                <Form.Control
                  type="number"
                  name="Phone"
                  placeholder="Enter Phone Number"
                  value={value.Phone}
                  onChange={handleChange}
                  isInvalid={!!fieldErrors.Phone}
                  required
                />
                <Form.Control.Feedback type="invalid">{fieldErrors.Phone}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="text-start d-block" style={{ fontWeight: "bold" }}>
                  Select Account Type
                </Form.Label>
                <Form.Select
                  name="Account_Type"
                  value={value.Account_Type}
                  onChange={handleChange}
                  isInvalid={!!fieldErrors.Account_Type}
                  required
                >
                  <option value="">Select Account Type</option>
                  <option value="Classic">Classic</option>
                  <option value="Premium">Premium</option>
                  <option value="Bussiness">Bussiness</option>
                  <option value="Enterprise">Enterprise</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">{fieldErrors.Account_Type}</Form.Control.Feedback>
              </Form.Group>

<Form.Group className="mb-3">
  <Form.Label className="text-start d-block" style={{ fontWeight: "bold" }}>
    Create Password
  </Form.Label>
  <div style={{ position: "relative" }}>
    <Form.Control
      type={showPassword ? "text" : "password"}
      name="Password"
      placeholder="Create Password"
      value={value.Password}
      onChange={handleChange}
      isInvalid={!!fieldErrors.Password}
      required
    />
    <span
      onClick={() => setShowPassword((prev) => !prev)}
      style={{
        position: "absolute",
        right: "30px",
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        fontSize: "1.5rem",
        color: "#D4AF37",
        zIndex: 2,
      }}
    >
      {showPassword ? <RiEyeFill /> : <RiEyeCloseFill />}
    </span>
  </div>
  {fieldErrors.Password && (
    <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
      {fieldErrors.Password}
    </Form.Control.Feedback>
  )}
</Form.Group>



              {error && (
                <div className="text-danger text-center mb-3">
                  {error}
                </div>
              )}

              <div className="d-flex justify-content-center mt-3">
                <button type="submit" className="search-btn" disabled={isLoading}>
                  {isLoading ? "Creating..." : "Create User"}
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreateUsers;
